<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('support_email')">
            <app-default-button
                :title="$fieldTitle('add', 'email', true)"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="support-email-table"
            :options="options"
            @action="triggerActions"
        />

        <app-ticket-support-email-create
            v-if="isModalActive"
            v-model="isModalActive"
            @close="isModalActive = false"
            :selected-url="selectedUrl"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('support-email-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";
import SupportEmailMixins from "../../Mixins/SupportEmailMixins";
import HelperMixin from "../../../../common/Mixin/Global/HelperMixin";
import {urlGenerator} from "../../../../common/Helper/AxiosHelper";

export default {
    name  : "AppSupportEmail",
    mixins: [HelperMixin, SupportEmailMixins],
    data() {
        return {
            TENANT_BASE_URL,
            isModalActive: false,
            selectedUrl  : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('detail')) {
                window.location.replace(urlGenerator(`/${TENANT_BASE_URL}settings/support-email/${row.id}/edit`))
            } else if (action.title === this.$t('edit')) {
                this.isModalActive = true;
                this.selectedUrl   = `${TENANT_BASE_URL}app/settings/support-email/${row.id}`;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>

<style scoped>
:deep(.datatable .datatable-td) {
    vertical-align: baseline !important;
}
</style>